import _ from 'lodash';

import {AsyncStatusesEnum} from '../../../../libs/shared/helpers/src/types/asyncStatuses';
import {ApplicationCommentList} from '../../../applications/bridge/v2/types/bridgeTypesV2';
import {serializeCommentForApplication} from '../../../helpers/models/applicationSerializationHelpers';
import {ActivityVisualTypesEnum} from '../../../models/api/activityModel';
import {CommentModel} from '../../../models/api/commentModel';
import {ThunkAction} from '../../appThunk';
import {ViewerPanelId} from '../../panels/panelStateBase';
import {makeGetViewerPanel} from '../../panels/viewer/viewerPanelSelectors';
import {ViewerPanelPageTypesEnum} from '../../panels/viewer/viewerPanelState';
import {getActivities, getComments} from '../dataSelectors';
import {getTeammates} from '../teammates/teammatesSelectors';

/*
 * Actions.
 */

export function applicationListConversationCommentsAction(
  panelId: ViewerPanelId,
  conversationId: number,
): ThunkAction<ApplicationCommentList> {
  return (dispatch, getState) => {
    const comments = dispatch(listLoadedCommentsAction(panelId, conversationId));
    const teammates = getTeammates(getState());
    return {
      nextPageToken: undefined,
      results: _(comments)
        .map((m) => {
          const teammate = teammates[m.authorId];
          if (!teammate) {
            return undefined;
          }
          return serializeCommentForApplication(teammate, m);
        })
        .compact()
        .value(),
    };
  };
}

/*
 * Helpers.
 */

export function listLoadedCommentsAction(
  panelId: ViewerPanelId,
  conversationId: number,
): ThunkAction<ReadonlyArray<CommentModel>> {
  return (_dispatch, getState) => {
    const panel = makeGetViewerPanel()(getState(), {panelId});
    const viewerPage = panel?.pages.current;

    // Make sure the viewer page is loaded for the correct conversation.
    if (
      viewerPage?.type !== ViewerPanelPageTypesEnum.SINGLE_CONVERSATION ||
      viewerPage.conversationId !== conversationId ||
      viewerPage.status !== AsyncStatusesEnum.LOADED
    ) {
      return [];
    }

    const comments = getComments(getState());
    const activities = getActivities(getState());

    return _(viewerPage.activities)
      .keys()
      .map((id) => activities[id])
      .compact()
      .sortBy((a) => a.date)
      .map((a) => a.visualType === ActivityVisualTypesEnum.COMMENT && comments[a.commentUid])
      .compact()
      .value();
  };
}
